import { createFileRoute } from "@tanstack/react-router";

import { ReadinessList } from "../../../features/readiness/components/readiness-list";

/**
 * `RPM-062`'s readiness page (`J-283`): every building in reach, what it still needs, and whether it
 * is ready. The server decides which buildings this account sees.
 */
function ReadinessScreen() {
  return <ReadinessList />;
}

export const Route = createFileRoute("/_authenticated/admin/readiness")({
  component: ReadinessScreen,
  staticData: { screenName: "Readiness" },
});
